import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppSchlossangerComponent } from './app-schlossanger/app-schlossanger.component';
import { AppkulturComponent } from './app-kultur/app-kultur.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTabsModule } from '@angular/material/tabs';
import { HttpClientModule } from '@angular/common/http';
import { SAService } from './sa-service.service';
import { KUService } from './ku-service.service';
import { TodoServiceService } from './todo-service.service';
import { FormsModule } from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatSliderModule} from '@angular/material/slider';
import { NgChartsModule } from 'ng2-charts';
import { AppReinhriedComponent } from './app-reinhried/app-reinhried.component';
import { AppTodoComponent } from './app-todo/app-todo.component';




@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AppSchlossangerComponent,
    AppkulturComponent,
    AppReinhriedComponent,
    AppTodoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatGridListModule,
    MatTabsModule,
    MatCardModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatTableModule,
    MatFormFieldModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    FormsModule,
    MatSliderModule,
    NgChartsModule,
    FlexLayoutModule
  ],
  providers: [SAService, KUService, TodoServiceService],
  bootstrap: [AppComponent]
})
export class AppModule { }
